import { combineReducers } from "redux";
import AppStateReducer from "./AppStateReducer";

const allReducers = combineReducers({
  AppState: AppStateReducer,
  // In this function, a peiece of a state is mapped to their
  // corresponding Reducer. This mapping will be used in our React components to access information
  // from a particular piece of state
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_APP') {
    const { AppState } = state;
    state = { AppState };
  }

  return allReducers(state, action);
};

export default rootReducer;
